import createReactContext from 'create-react-context';
export const FormContext = createReactContext({
    labelAlign: 'right',
    vertical: false,
});
